const setting = {
  buttonsStyling: false,
  reverseButtons: true,
  customClass: {
    container: 'modal',
    title: 'sweetalert-custom-title',
    htmlContainer: 'sweetalert-custom-text',
    confirmButton: 'btn btn-primary',
    cancelButton: 'btn btn-outline-primary',
  },
};

export default setting;
